import { findElstAtoms, modifyElstAtomWithMultipleEntries } from '../../../ts/dist/mp4_elst';
import { parseTime } from './utils';


const apply = document.getElementById('apply');
const download = document.getElementById('download');


apply.addEventListener('click', applyElst);
download.addEventListener('click', downloadVideo);



let uint8Array;
async function loadVideoFromURL(url) {
    try {
        // Fetch the video
        const response = await fetch(url);
        const blob = await response.blob();

        // Convert blob to ArrayBuffer
        const arrayBuffer = await blob.arrayBuffer();
        uint8Array = new Uint8Array(arrayBuffer);

        // Create a new Blob from the Uint8Array
        const newBlob = new Blob([uint8Array], { type: blob.type });

        // Create an object URL and assign it to the video element
        const videoURL = URL.createObjectURL(newBlob);
        video.src = videoURL;
    } catch (error) {
        console.error("Error loading video:", error);
    }
}


video.controls = true;

const videoUrl = "./bbb.mp4"; // Replace with your video URL
loadVideoFromURL(videoUrl);

function applyElst() {
    const entries = [];
    for (let i = 1; i <= 5; i++) {
        entries.push({
            duration: document.getElementById(`entry${i}-duration`).value,
            mediatime: document.getElementById(`entry${i}-mediatime`).value,
        });
    }
    if (uint8Array) {
        // Process video
        const edstAtoms = findElstAtoms(uint8Array);
        if (edstAtoms) {
            for (let i = 0; i < 5; i++) {
                // edstAtoms[0].entries[i]
                const startTimeUs = BigInt(Math.round(parseTime(entries[i].mediatime) * 1_000_000));
                const endTimeUs = BigInt(Math.round(parseTime(entries[i].duration) * 1_000_000 + parseTime(entries[i].mediatime) * 1_000_000));

                const videoElstAtom = edstAtoms[0];
                const audioElstAtom = edstAtoms[1];

                modifyElstAtomWithMultipleEntries(uint8Array, videoElstAtom, startTimeUs, endTimeUs, i + 1);
                modifyElstAtomWithMultipleEntries(uint8Array, audioElstAtom, startTimeUs, endTimeUs, i + 1);
            }
        }
    }
    // Create a new Blob from the Uint8Array
    const newBlob = new Blob([uint8Array], { type: "video/mp4" });
    // Create an object URL and assign it to the video element
    const videoURL = URL.createObjectURL(newBlob);
    video.src = videoURL;
}

function downloadVideo() {                // Create and trigger download
    const blob = new Blob([uint8Array], { type: 'video/mp4' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = "bbb.mp4";
    link.click();

    URL.revokeObjectURL(url);
}